var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGovtfilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 56 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "085---Government-Grants",
    fill: "#52771A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m15 30h4v12h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 26v16h2v-16c0-.5522847-.44771525-1-1-1s-1 .4477153-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m0 45v3h24v-4h-23c-.55228475 0-1 .4477153-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m20 24c-2.3756524.0014527-4.4229713 1.6727334-4.9 4h9.8c-.4812292-2.324722-2.5259997-3.9939224-4.9-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m21 12.055v-3.362l4.646-1.741c.8115727-.30599418 1.3487749-1.08265769 1.3487749-1.95s-.5372022-1.64400582-1.3487749-1.95l-4.646-1.745v-.307c0-.55228475-.4477153-1-1-1s-1 .44771525-1 1v11.055c-4.5465453.2030143-8.7801855 2.3727549-11.6 5.945h25.2c-2.8198145-3.5722451-7.0534547-5.7419857-11.6-5.945zm3.944-7.134v.158l-3.944 1.478v-3.114z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m4 26c0-1.6568542 1.34314575-3 3-3s3 1.3431458 3 3v16h3v-13c.0087981-3.8623431 3.1376569-6.9912019 7-7 3.8641657.0044086 6.9955914 3.1358343 7 7v9h3v-12c.0049422-1.6548028 1.3451972-2.9950578 3-3 1.6568542 0 3 1.3431458 3 3v12h2v-17c0-.5522847-.4477153-1-1-1h-34c-.55228475 0-1 .4477153-1 1v21h2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m26 43c1.6548028-.0049422 2.9950578-1.3451972 3-3h-2c-.5522847 0-1 .4477153-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m21 42h3v-2c.0042869-.7102221.3849109-1.3648954 1-1.72v-8.28h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m32 26v12h2v-12c.0044841-.2605125-.1007553-.5109097-.29-.69-.1817916-.1996295-.4400102-.3123728-.71-.31-.5522847 0-1 .4477153-1 1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m51 40h-20c0 2.7614237-2.2385763 5-5 5v8c2.7614237 0 5 2.2385763 5 5h20c-.0039999-1.3273046.5214997-2.6013996 1.4600501-3.5399499.9385503-.9385504 2.2126453-1.46405 3.5399499-1.4600501v-8c-2.7614237 0-5-2.2385763-5-5zm-20 12c-1.6568542 0-3-1.3431458-3-3s1.3431458-3 3-3 3 1.3431458 3 3c-.0049422 1.6548028-1.3451972 2.9950578-3 3zm10 2c-2.7614237 0-5-2.2385763-5-5s2.2385763-5 5-5 5 2.2385763 5 5c0 1.3260824-.5267842 2.597852-1.4644661 3.5355339s-2.2094515 1.4644661-3.5355339 1.4644661zm13-5c0 1.6568542-1.3431458 3-3 3s-3-1.3431458-3-3 1.3431458-3 3-3c1.6548028.0049422 2.9950578 1.3451972 3 3z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 51,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41,
    cy: 49,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m53 40c0 1.6568542 1.3431458 3 3 3v-2c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m53 58h2c.5522847 0 1-.4477153 1-1v-2c-1.6548028.0049422-2.9950578 1.3451972-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m26 55v2c0 .5522847.4477153 1 1 1h2c-.0049422-1.6548028-1.3451972-2.9950578-3 3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovtfilled);
export default __webpack_public_path__ + "static/media/Govtfilled.483458224fc01a9785a97e9f2cccf250.svg";
export { ForwardRef as ReactComponent };